import { PageCategory, PageConfigWithCharts } from '../../../shared/features/ng-redux/page/page.models';

import { buildChartOptions, patchChart, patchPage } from './app-mapper.utils';
import { ApplicationConfigWithPages } from '../../../shared/features/ng-redux/app/appConfig.models';
import {
  CHART_UI_DONUT_TOPN,
  DEFAULT_DEVICE_FILTER_BAR_CONFIG,
  WATCHLIST_CURRENT_PAGE,
  WATCHLIST_CURRENT_TABLE,
  WATCHLIST_DEPARTED_PAGE,
  WATCHLIST_DEPARTED_SUMMARY_CHART_ITEMS,
  WATCHLIST_DEPARTED_TABLE,
  WATCHLIST_PAGE,
  WATCHLIST_SUMMARY_CHART_ITEMS,
} from './app-mapper.constants';
import { CONSTANTS } from '../../../shared/localizations/dictionary';
import {
  BarChartConfig,
  ChartTypeEnum,
  DonutChartConfig,
  ElementTypeEnum,
  SummaryChartConfig,
  TableConfig,
} from '../../../../app/shared/models/chart.models';
import { InsSelectionType, TableRenderEnum } from '@nx-fe/table';

function patchWatchListPage(page: PageConfigWithCharts) {
  page.filterBarVisible = true;
  page.pageCategory = PageCategory.WATCHLIST;
  page.filterBarConfig = DEFAULT_DEVICE_FILTER_BAR_CONFIG;
}

export function mapWatchlistConfig(app: ApplicationConfigWithPages): ApplicationConfigWithPages {
  patchPage(app, WATCHLIST_PAGE, patchWatchListPage);
  app.name = 'Analysis_Profile_Tab_Watchlist';
  app.dashboardType = CONSTANTS.DASHBOARD_TYPES.WATCHLIST;
  return app;
}

export function mapWatchlistCurrentConfig(app: ApplicationConfigWithPages): ApplicationConfigWithPages {
  patchPage(app, WATCHLIST_CURRENT_PAGE, patchWatchListCurrentPage);
  app.name = 'Watchlist_App_Name_Current';
  app.dashboardType = CONSTANTS.DASHBOARD_TYPES.WATCHLIST;
  return app;
}

function patchWatchListCurrentPage(page: PageConfigWithCharts) {
  page.filterBarVisible = true;
  page.pageCategory = PageCategory.WATCHLIST;
  page.filterBarConfig = DEFAULT_DEVICE_FILTER_BAR_CONFIG;
  page.predefinedCharts = [
    {
      category: {
        name: 'Device_Charts_Category_Name_Caption',
        icon: 'insight-icon-device',
        tooltip: 'Device_Charts_Category_Name_Tooltip_Caption',
      },

      charts: [
        buildChartOptions(page.charts, 'wlcManufacturer', 'Device_Charts_Category_Chart_Caption_Top_Manufacturers'),
        buildChartOptions(page.charts, 'wlcModel', 'as_chart_predefined_model_name'),
        buildChartOptions(page.charts, 'wlcOSVersion', 'as_chart_predefined_osVersion_name'),
      ],
    },
    {
      category: {
        name: 'Conditions_Charts_Category_Name_Caption',
        icon: 'insight-Watch-List',
        tooltip: 'wl_conditions_charts_category_tooltip',
      },
      charts: [
        buildChartOptions(page.charts, 'wlcConditions', 'wl_conditions_charts_category'),
        buildChartOptions(page.charts, 'wlcDaysIn', 'wl_daysIn_charts_category'),
      ],
    },
  ];

  patchChart(page.charts, 'wlcDevSummary', (chart: SummaryChartConfig) => {
    chart.elementType = ElementTypeEnum.SUMMARY;
    chart.name = 'devices_summary_name';
    chart.fullName = undefined;
    chart.layout = '33p';
    chart.fullName = 'devices_summary_full_name_dashboards';
    chart.items = WATCHLIST_SUMMARY_CHART_ITEMS;
  });

  patchChart(page.charts, 'wlcManufacturer', (chart: DonutChartConfig) => {
    chart.fullName = 'Manufacturers_fullName';
    chart.reportSummary = 'Manufacturers_reportsummary';
    chart.name = 'wlc_chart_manufacturers_name';
    chart.type = ChartTypeEnum.DONUT;
    chart.elementType = 'chart';
    chart.layout = '33p';
    chart.tag = {
      name: 'wlc_chart_manufacturers_name',
      parameters: ['topN'],
    };
    chart.dimension = {
      dimensionId: 'name',
      label: 'android_ver_label',
      noDataLabel: 'no_data_label',
    };
    chart.filter = {
      attribute: 'filter',
      type: 'mapped',
    };
    chart.filters = {
      topN: 5,
    };
    chart.tooltip = {
      label: "`${xsI18nPipe.transform('wlc_chart_manufacturer_tooltip_label', this.point.name)}`",
      labelArgs: ['wlc_chart_manufacturer_tooltip_label', 'this.point.name'],
      value:
        "`${xsI18nPipe.transform('wlc_chart_manufacturer_tooltip_value', this.point.y,  (this.point.y/this.point.devcount*100).toFixed(2).replace(/\\.?0+$/,''), this.point.devcount)}`",
      valueArgs: [
        'wlc_chart_manufacturer_tooltip_value',
        'this.point.y',
        'percentage(this.point.y, this.point.devcount)',
        'this.point.devcount',
      ],
    };
    chart.uiSettings = [CHART_UI_DONUT_TOPN];
  });

  patchChart(page.charts, 'wlcModel', (chart: DonutChartConfig) => {
    chart.fullName = 'Model_fullName';
    chart.reportSummary = 'Model_reportsummary';
    chart.name = 'wlc_chart_models_name';
    chart.type = ChartTypeEnum.DONUT;
    chart.elementType = 'chart';
    chart.layout = '33p';
    chart.tag = {
      name: 'wlc_chart_models_name',
      parameters: ['topN'],
    };

    chart.tooltip = {
      label: "`${xsI18nPipe.transform('wlc_chart_model_tooltip_label', this.point.name)}`",
      labelArgs: ['wlc_chart_model_tooltip_label', 'this.point.name'],
      value:
        "`${xsI18nPipe.transform('wlc_chart_model_tooltip_value', this.point.y,  (this.point.y/this.point.devcount*100).toFixed(2).replace(/\\.?0+$/,''), this.point.devcount)}`",
      valueArgs: [
        'wlc_chart_model_tooltip_value',
        'this.point.y',
        'percentage(this.point.y, this.point.devcount)',
        'this.point.devcount',
      ],
    };
    chart.dimension = {
      dimensionId: 'name',
      label: 'Manufacturer',
      noDataLabel: 'noData',
    };
    chart.filter = {
      attribute: 'filter',
      type: 'mapped',
    };
    chart.filters = {
      topN: 5,
    };
    chart.uiSettings = [CHART_UI_DONUT_TOPN];
  });

  patchChart(page.charts, 'wlcOSVersion', (chart: BarChartConfig) => {
    chart.fullName = 'OSVersion_fullName';
    chart.reportSummary = 'OSVersion_reportsummary';
    chart.name = 'wlc_chart_OS_versions_name';
    chart.type = ChartTypeEnum.COLUMN;
    chart.elementType = 'chart';
    chart.layout = '33p';

    chart.dimension = {
      dimensionId: 'name',
      label: 'Column_Name_Os_Version',
      noDataLabel: 'no_data_label',
    };
    chart.metric = {
      metricId: 'metric',
      label: 'device_count_label',
    };
    chart.filter = {
      attribute: 'filter',
      type: 'mapped',
    };
    chart.tag = {
      name: 'wlc_chart_OS_versions_name',
      parameters: ['topN'],
    };
    chart.tooltip = {
      label: "`${xsI18nPipe.transform('wlc_chart_version_tooltip_label', this.point.name)}`",
      labelArgs: ['wlc_chart_version_tooltip_label', 'this.point.name'],
      value:
        "`${xsI18nPipe.transform('wlc_chart_version_tooltip_value', this.point.y,  (this.point.y/this.point.devcount*100).toFixed(2).replace(/\\.?0+$/,''), this.point.devcount)}`",
      valueArgs: [
        'wlc_chart_version_tooltip_value',
        'this.point.y',
        'percentage(this.point.y, this.point.devcount)',
        'this.point.devcount',
      ],
    };
    chart.colorByPoint = true;
    chart.integerOnly = true;
    chart.filters = {
      topN: 5,
    };
    chart.uiSettings = [CHART_UI_DONUT_TOPN];
  });

  patchChart(page.charts, 'wlcConditions', (chart: BarChartConfig) => {
    chart.integerOnly = true;
    chart.fullName = 'wlc_conditions_sql_fullName';
    chart.reportSummary = 'wlc_conditions_sql_reportsummary';
    chart.name = 'wlc_chart_conditions';
    chart.type = ChartTypeEnum.COLUMN;
    chart.elementType = 'chart';
    chart.layout = '66p';

    chart.dimension = {
      dimensionId: 'label',
      label: 'wlc_chart_conditions_dimension_label',
      noDataLabel: 'no_data_label',
    };
    chart.metric = {
      metricId: 'y',
      label: 'device_count_label',
    };
    chart.filter = {
      attribute: 'filter',
      type: 'mapped',
    };
    chart.tag = {
      name: 'wl_condition_name',
    };
    chart.tooltip = {
      label: "`${xsI18nPipe.transform('wlc_chart_conditions_tooltip_label', xsI18nPipe.transform(this.point.label))}`",
      labelArgs: ['wlc_chart_conditions_tooltip_label', 'xsI18nPipe.transform(this.point.label)'],
      value:
        "`${xsI18nPipe.transform('wlc_chart_conditions_tooltip_value', this.point.y,  (this.point.y/this.point.wlDevices*100).toFixed(2).replace(/\\.?0+$/,''), this.point.wlDevices)}`",
      valueArgs: [
        'wlc_chart_conditions_tooltip_value',
        'this.point.y',
        'percentage(this.point.y, this.point.wlDevices)',
        'this.point.wlDevices',
      ],
    };
  });

  patchChart(page.charts, 'wlcDaysIn', (chart: BarChartConfig) => {
    chart.integerOnly = true;
    chart.fullName = 'daysIn_sql_fullName';
    chart.reportSummary = 'daysIn_sql_reportsummary';
    chart.name = 'wlc_chart_days_in';
    chart.type = ChartTypeEnum.COLUMN;
    chart.elementType = 'chart';
    chart.layout = '66p';
    chart.filter = {
      attribute: 'filter',
      type: 'mapped',
    };
    chart.dimension = {
      dimensionId: 'label',
      label: 'wl_daysIn_charts_label',
      noDataLabel: 'no_data_label',
    };
    chart.metric = {
      metricId: 'y',
      label: 'device_count_label',
    };
    chart.tag = {
      name: 'wl_daysIn_charts_category',
    };
    chart.tooltip = {
      label: "`${xsI18nPipe.transform('wlc_chart_daysIn_tooltip_label', xsI18nPipe.transform(this.point.label))}`",
      labelArgs: ['wlc_chart_daysIn_tooltip_label', 'xsI18nPipe.transform(this.point.label)'],
      value:
        "`${xsI18nPipe.transform('wlc_chart_daysIn_tooltip_value', this.point.y,  (this.point.y/this.point.wlDevices*100).toFixed(2).replace(/\\.?0+$/,''), this.point.wlDevices)}`",
      valueArgs: [
        'wlc_chart_daysIn_tooltip_value',
        'this.point.y',
        'percentage(this.point.y, this.point.wlDevices)',
        'this.point.wlDevices',
      ],
    };
  });

  patchChart(page.charts, 'wlcCheckin', (chart: DonutChartConfig) => {
    chart.fullName = 'checkIn_sql_fullName';
    chart.reportSummary = 'checkIn_sql_reportsummary';
    chart.name = 'wlc_chart_check_in';
    chart.type = ChartTypeEnum.DONUT;
    chart.elementType = 'chart';
    chart.layout = '33p';
    chart.displayCondition = [
      {
        operation: 'EQUAL',
        filterIdx: 'filterChartIdx-wlcConditions',
        filterValue: [101],
        filterLabel: 'wl_checkin_name',
      },
    ];
    chart.dimension = {
      dimensionId: 'name',
      label: 'wl_checkIn_charts_category',
      noDataLabel: 'no_data_label',
    };
    chart.metric = {
      metricId: 'metric',
      label: 'device_count_label',
    };
    chart.filter = {
      attribute: 'filter',
      type: 'mapped',
    };
    chart.tag = {
      name: 'wl_checkIn_charts_category',
    };
    chart.tooltip = {
      label: "`${xsI18nPipe.transform('wlc_chart_checkIn_tooltip_label', this.point.name)}`",
      labelArgs: ['wlc_chart_checkIn_tooltip_label', 'this.point.name'],
      value:
        "`${xsI18nPipe.transform('wlc_chart_checkIn_tooltip_value',   (this.point.y/this.point.wlDevices*100).toFixed(2).replace(/\\.?0+$/,''), this.point.wlDevices)}`",
      valueArgs: [
        'wlc_chart_checkIn_tooltip_value',
        'this.point.y',
        'percentage(this.point.y, this.point.wlDevices)',
        'this.point.wlDevices',
      ],
    };
  });

  patchChart(page.charts, WATCHLIST_CURRENT_TABLE, (chart: TableConfig) => {
    chart.name = 'Ticket_List_Devices_Header';
    chart.selectionType = InsSelectionType.multiple;
    chart.childTableKey = 'McDeviceId';
    chart.childTableTemplate = 'watch-conditions';
    chart.selectionText = 'device_selected_label';
    chart.selectionTextPlural = 'device_selected_label';
    chart.filters = {
      sortAttribute: 'DeviceName',
      sortDirection: 'asc',
      pageSize: 50,
      pageSkip: 0,
    };
    chart.rowActions = [
      {
        action: 'customAttributes',
        tooltip: 'custom_attr_title',
        icon: 'insight-icon-deviceinfo',
      },
      {
        action: 'snoozeDevice',
        tooltip: 'snooze_device_s_label',
        icon: 'insight-icon-snooze',
      },
      {
        action: 'createIncident',
        tooltip: 'create_incident_label',
        icon: 'insight-icon-newdata',
      },
    ];
    chart.tableAttributes = [
      {
        id: 'DeviceName',
        label: 'Column_Name_Device_Name',
        renderer: TableRenderEnum.STRING,
      },
      {
        id: 'McDeviceId',
        label: 'Column_Name_Device_Id',
        renderer: TableRenderEnum.STRING,
      },
      {
        id: 'DeviceGroup',
        label: 'Column_Name_Device_Group',
        renderer: TableRenderEnum.STRING,
      },
      {
        id: 'GroupPath',
        label: 'group_path_label',
        renderer: TableRenderEnum.STRING,
      },
      {
        id: 'TopicCnt',
        label: 'watchlist_condition_label',
        renderer: TableRenderEnum.ICON,
        iconClass: 'insight-icon_intensivecare',
      },
      {
        id: 'DaysIn',
        label: 'DaysIn_label',
        renderer: TableRenderEnum.STRING,
      },
      {
        id: 'ModelName',
        label: 'Column_Name_Model',
        renderer: TableRenderEnum.STRING,
      },
      {
        id: 'ManufacturerName',
        label: 'label_Manufacturer',
        renderer: TableRenderEnum.STRING,
      },
      {
        id: 'OSVersion',
        label: 'Column_Name_Os_Version',
        renderer: TableRenderEnum.STRING,
      },
      {
        id: 'AgentVersion',
        label: 'agent_version_label',
        renderer: TableRenderEnum.STRING,
      },
      {
        id: 'MACAddress',
        label: 'mac_address_label',
        renderer: TableRenderEnum.STRING,
      },
      {
        id: 'CellularCarrierName',
        label: 'cellular_carrier_label',
        renderer: TableRenderEnum.STRING,
        shouldTranslate: true,
      },
      {
        id: 'LastCheckinTime',
        label: 'check_in_label',
        renderer: TableRenderEnum.DATE,
        rendererParams: {
          dateFormat: 'MMM DD YYYY [at] hh:mm A',
        },
      },
    ];
  });
}

export function mapWatchlistDepartedConfig(app: ApplicationConfigWithPages): ApplicationConfigWithPages {
  patchPage(app, WATCHLIST_DEPARTED_PAGE, patchWatchListDepartedPage);
  app.name = 'Watchlist_App_Name_Departed';
  app.dashboardType = CONSTANTS.DASHBOARD_TYPES.WATCHLIST;
  return app;
}

function patchWatchListDepartedPage(page: PageConfigWithCharts) {
  page.filterBarVisible = true;
  page.pageCategory = PageCategory.WATCHLIST;
  page.filterBarConfig = DEFAULT_DEVICE_FILTER_BAR_CONFIG;
  page.dateFilterTypes = ['Today', 'Last 7 Days'];

  page.predefinedCharts = [
    {
      category: {
        name: 'Device_Charts_Category_Name_Caption',
        icon: 'insight-icon-device',
        tooltip: 'Device_Charts_Category_Name_Tooltip_Caption',
      },
      charts: [
        buildChartOptions(page.charts, 'wldManufacturer', 'Device_Charts_Category_Chart_Caption_Top_Manufacturers'),
        buildChartOptions(page.charts, 'wldModel', 'as_chart_predefined_model_name'),
        buildChartOptions(page.charts, 'wldOSVersion', 'as_chart_predefined_osVersion_name'),
      ],
    },
    {
      category: {
        name: 'Conditions_Charts_Category_Name_Caption',
        icon: 'insight-Watch-List',
        tooltip: 'wl_conditions_charts_category_tooltip',
      },
      charts: [
        buildChartOptions(page.charts, 'wldConditions', 'wl_conditions_charts_category'),
        buildChartOptions(page.charts, 'wldDaysOut', 'wld_chart_days_out'),
      ],
    },
  ];

  patchChart(page.charts, 'wldDevSummary', (chart: SummaryChartConfig) => {
    chart.elementType = ElementTypeEnum.SUMMARY;
    chart.name = 'devices_summary_name';
    chart.fullName = undefined;
    chart.layout = '33p';
    chart.fullName = 'devices_summary_full_name_dashboards';
    chart.items = WATCHLIST_DEPARTED_SUMMARY_CHART_ITEMS;
  });

  patchChart(page.charts, 'wldManufacturer', (chart: DonutChartConfig) => {
    chart.fullName = 'Manufacturers_fullName';
    chart.reportSummary = 'Manufacturers_reportsummary';
    chart.name = 'wld_chart_manufacturers_name';
    chart.type = ChartTypeEnum.DONUT;
    chart.elementType = 'chart';
    chart.layout = '33p';
    chart.tag = {
      name: 'wld_chart_manufacturers_name',
      parameters: ['topN'],
    };
    chart.dimension = {
      dimensionId: 'name',
      label: 'android_ver_label',
      noDataLabel: 'no_data_label',
    };
    chart.filter = {
      attribute: 'filter',
      type: 'mapped',
    };
    chart.tooltip = {
      label: "`${xsI18nPipe.transform('battery_chart_manufacturer_tooltip_label', this.point.name)}`",
      labelArgs: ['battery_chart_manufacturer_tooltip_label', 'this.point.name'],
      value:
        "`${xsI18nPipe.transform('battery_chart_manufacturer_tooltip_value', this.point.y,  (this.point.y/this.point.devcount*100).toFixed(2).replace(/\\.?0+$/,''), this.point.devcount)}`",
      valueArgs: [
        'battery_chart_manufacturer_tooltip_value',
        'this.point.y',
        'percentage(this.point.y, this.point.devcount)',
        'this.point.devcount',
      ],
    };
    chart.filters = {
      topN: 5,
    };
    chart.uiSettings = [CHART_UI_DONUT_TOPN];
  });

  patchChart(page.charts, 'wldModel', (chart: DonutChartConfig) => {
    chart.fullName = 'Model_fullName';
    chart.reportSummary = 'Model_reportsummary';
    chart.name = 'wld_chart_models_name';
    chart.type = ChartTypeEnum.DONUT;
    chart.elementType = 'chart';
    chart.layout = '33p';
    chart.tag = {
      name: 'wld_chart_models_name',
      parameters: ['topN'],
    };

    chart.tooltip = {
      label: "`${xsI18nPipe.transform('battery_chart_models_tooltip_label', this.point.name)}`",
      labelArgs: ['battery_chart_models_tooltip_label', 'this.point.name'],
      value:
        "`${xsI18nPipe.transform('battery_chart_models_tooltip_value', this.point.y,  (this.point.y/this.point.devcount*100).toFixed(2).replace(/\\.?0+$/,''), this.point.devcount)}`",
      valueArgs: [
        'battery_chart_models_tooltip_value',
        'this.point.y',
        'percentage(this.point.y, this.point.devcount)',
        'this.point.devcount',
      ],
    };
    chart.dimension = {
      dimensionId: 'name',
      label: 'Manufacturer',
      noDataLabel: 'noData',
    };
    chart.filter = {
      attribute: 'filter',
      type: 'mapped',
    };
    chart.filters = {
      topN: 5,
    };
    chart.uiSettings = [CHART_UI_DONUT_TOPN];
  });

  patchChart(page.charts, 'wldOSVersion', (chart: BarChartConfig) => {
    chart.fullName = 'OSVersion_fullName';
    chart.reportSummary = 'OSVersion_reportsummary';
    chart.name = 'wld_chart_OS_versions_name';
    chart.type = ChartTypeEnum.COLUMN;
    chart.elementType = 'chart';
    chart.layout = '33p';

    chart.metric = {
      metricId: 'metric',
      label: 'device_count_label',
    };
    chart.dimension = {
      dimensionId: 'name',
      label: 'label_OSVersion',
      noDataLabel: 'no_data_label',
    };
    chart.filter = {
      attribute: 'filter',
      type: 'mapped',
    };
    chart.tag = {
      name: 'wld_chart_OS_versions_name',
      parameters: ['topN'],
    };
    chart.tooltip = {
      label: "`${xsI18nPipe.transform('battery_chart_os_version_tooltip_label', this.point.name)}`",
      labelArgs: ['battery_chart_os_version_tooltip_label', 'this.point.name'],
      value:
        "`${xsI18nPipe.transform('battery_chart_os_version_tooltip_value', this.point.y,  (this.point.y/this.point.devcount*100).toFixed(2).replace(/\\.?0+$/,''), this.point.devcount)}`",
      valueArgs: [
        'battery_chart_os_version_tooltip_value',
        'this.point.y',
        'percentage(this.point.y, this.point.devcount)',
        'this.point.devcount',
      ],
    };
    chart.colorByPoint = true;
    chart.integerOnly = true;
    chart.filters = {
      topN: 5,
    };
    chart.uiSettings = [CHART_UI_DONUT_TOPN];
  });

  patchChart(page.charts, 'wldConditions', (chart: BarChartConfig) => {
    chart.integerOnly = true;
    chart.fullName = 'wld_conditions_sql_fullName';
    chart.reportSummary = 'wld_conditions_sql_reportsummary';
    chart.name = 'wld_chart_conditions';
    chart.type = ChartTypeEnum.COLUMN;
    chart.elementType = 'chart';
    chart.layout = '66p';
    chart.metric = {
      metricId: 'metric',
      label: 'device_count_label',
    };
    chart.dimension = {
      dimensionId: 'label',
      label: 'wlc_chart_conditions_dimension_label',
      noDataLabel: 'no_data_label',
    };
    chart.filter = {
      attribute: 'filter',
      type: 'mapped',
    };
    chart.tag = {
      name: 'wl_condition_name',
    };
    chart.tooltip = {
      label: "`${xsI18nPipe.transform('wld_chart_conditions_tooltip_label', xsI18nPipe.transform(this.point.label))}`",
      labelArgs: ['wld_chart_conditions_tooltip_label', 'xsI18nPipe.transform(this.point.label)'],
      value:
        "`${xsI18nPipe.transform('wld_chart_conditions_tooltip_value', this.point.y,  (this.point.y/this.point.wlDevices*100).toFixed(2).replace(/\\.?0+$/,''), this.point.wlDevices)}`",
      valueArgs: [
        'wld_chart_conditions_tooltip_value',
        'this.point.y',
        'percentage(this.point.y, this.point.wlDevices)',
        'this.point.wlDevices',
      ],
    };
  });

  patchChart(page.charts, 'wldDaysOut', (chart: BarChartConfig) => {
    chart.integerOnly = true;
    chart.fullName = 'daysOut_sql_fullName';
    chart.reportSummary = 'daysOut_sql_reportsummary';
    chart.name = 'wld_chart_days_out';
    chart.type = ChartTypeEnum.COLUMN;
    chart.elementType = 'chart';
    chart.layout = '50p';
    chart.metric = {
      metricId: 'metric',
      label: 'device_count_label',
    };
    chart.dimension = {
      dimensionId: 'label',
      label: 'wl_daysOut_charts_label',
      noDataLabel: 'no_data_label',
    };
    chart.filter = {
      attribute: 'filter',
      type: 'mapped',
    };
    chart.tag = {
      name: 'wld_chart_days_out',
    };
    chart.tooltip = {
      label: "`${xsI18nPipe.transform('wld_chart_daysOut_tooltip_label',  xsI18nPipe.transform(this.point.label))}`",
      labelArgs: ['wld_chart_daysOut_tooltip_label', 'xsI18nPipe.transform(this.point.label)'],
      value:
        "`${xsI18nPipe.transform('wld_chart_daysOut_tooltip_value', this.point.y,  (this.point.y/this.point.wlDevices*100).toFixed(2).replace(/\\.?0+$/,''), this.point.wlDevices)}`",
      valueArgs: [
        'wld_chart_daysOut_tooltip_value',
        'this.point.y',
        'percentage(this.point.y, this.point.wlDevices)',
        'this.point.wlDevices',
      ],
    };
  });

  patchChart(page.charts, WATCHLIST_DEPARTED_TABLE, (chart: TableConfig) => {
    chart.name = 'Ticket_List_Devices_Header';
    chart.selectionType = InsSelectionType.multiple;
    chart.selectionText = 'device_selected_label';
    chart.selectionTextPlural = 'device_selected_label';
    chart.childTableKey = 'McDeviceId';
    chart.childTableTemplate = 'watch-conditions';
    chart.filters = {
      sortAttribute: 'DeviceName',
      sortDirection: 'asc',
      pageSize: 50,
      pageSkip: 0,
    };
    chart.rowActions = [
      {
        action: 'customAttributes',
        tooltip: 'custom_attr_title',
        icon: 'insight-icon-deviceinfo',
      },
      {
        action: 'snoozeDevice',
        tooltip: 'snooze_device_s_label',
        icon: 'insight-icon-snooze',
      },
      {
        action: 'createIncident',
        tooltip: 'create_incident_label',
        icon: 'insight-icon-newdata',
      },
    ];
    chart.tableAttributes = [
      {
        id: 'DeviceName',
        label: 'Column_Name_Device_Name',
        renderer: TableRenderEnum.STRING,
      },
      {
        id: 'McDeviceId',
        label: 'Column_Name_Device_Id',
        renderer: TableRenderEnum.STRING,
      },
      {
        id: 'DeviceGroup',
        label: 'Column_Name_Device_Group',
        renderer: TableRenderEnum.STRING,
      },
      {
        id: 'GroupPath',
        label: 'group_path_label',
        renderer: TableRenderEnum.STRING,
      },
      {
        id: 'DaysIn',
        label: 'DaysIn_label',
        renderer: TableRenderEnum.STRING,
      },
      {
        id: 'TopicCnt',
        label: 'watchlist_condition_label',
        renderer: TableRenderEnum.ICON,
        iconClass: 'insight-icon_intensivecare',
      },
      {
        id: 'EntryTime',
        label: 'entry_time_label',
        renderer: TableRenderEnum.DATE,
      },
      {
        id: 'ExitTime',
        label: 'exit_time_label',
        renderer: TableRenderEnum.DATE,
      },
      {
        id: 'ModelName',
        label: 'Column_Name_Model',
        renderer: TableRenderEnum.STRING,
      },
      {
        id: 'ManufacturerName',
        label: 'label_Manufacturer',
        renderer: TableRenderEnum.STRING,
      },
      {
        id: 'OSVersion',
        label: 'Column_Name_Os_Version',
        renderer: TableRenderEnum.STRING,
      },
      {
        id: 'AgentVersion',
        label: 'agent_version_label',
        renderer: TableRenderEnum.STRING,
      },
      {
        id: 'MACAddress',
        label: 'mac_address_label',
        renderer: TableRenderEnum.STRING,
      },
      {
        id: 'CellularCarrierName',
        label: 'cellular_carrier_label',
        renderer: TableRenderEnum.STRING,
        shouldTranslate: true,
      },
    ];
  });
}
